import { Layout, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

import React from 'react'
export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        inProgress={true}
        category={data.category}
        changelog={changelog[data.title].changelog}
        description={data.description}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        <Showcase
          site={data.site}
          switch={false}
          title="Responsive Grid"
          text="Responsive modifiers enable specifying different column sizes, offsets, alignment and distribution at xs, sm, md & lg viewport widths. These classes are stackable to create dynamic responsive behavior. If the smallest viewport chosen isn't reached (ex: no viewport smaller than md is present but the screen is smaller than the md viewport), the content will fill the full 12 columns."
        >
          <div class="l-flex-row">
            <div class="l-flex-col--xs-12">
              <div class="box">12</div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs-4">
              <div class="box">4</div>
            </div>
            <div class="l-flex-col--xs-8">
              <div class="box">8</div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--md-6">
              <div class="box">6</div>
            </div>
            <div class="l-flex-col--xs-6">
              <div class="box">6</div>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          switch={false}
          title="Offsets"
          text="Offset a column to the right side of the container using a class modifier. These classes are stackable to create dynamic responsive behavior."
        >
          <div class="l-flex-row"></div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs-offset-4 l-flex-col--xs-8">
              <div class="box">8</div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs-offset-6 l-flex-col--xs-6">
              <div class="box">6</div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs-offset-left-auto l-flex-col--xs-3">
              <div class="box">3</div>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          switch={false}
          title="Auto Width"
          text="The auto-width grid lets you add any number of auto sizing columns to a row and the grid will figure it out."
        >
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box">col</div>
            </div>
            <div class="l-flex-col--xs">
              <div class="box">col</div>
            </div>
            <div class="l-flex-col--xs">
              <div class="box">col</div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box">col</div>
            </div>
            <div class="l-flex-col--xs">
              <div class="box">col</div>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          switch={false}
          title="Nesting"
          text="Nest grids inside grids inside grids. Simply add a new row inside of a grid and repeat as many times as needed."
        >
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box box--bg">
                <div class="l-flex-row">
                  <div class="l-flex-col--xs">
                    <div class="box">col</div>
                  </div>
                  <div class="l-flex-col--xs">
                    <div class="box">col</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs-6">
              <div class="box box--bg">
                <div class="l-flex-row">
                  <div class="l-flex-col--xs">
                    <div class="box">col</div>
                  </div>
                  <div class="l-flex-col--xs">
                    <div class="box">col</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="l-flex-col--xs-6">
              <div class="box box--bg">
                <div class="l-flex-row">
                  <div class="l-flex-col--xs">
                    <div class="box">col</div>
                  </div>
                  <div class="l-flex-col--xs">
                    <div class="box">col</div>
                  </div>
                  <div class="l-flex-col--xs">
                    <div class="box">col</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          switch={false}
          title="Alignment"
          text="Add classes to elements to align children to the start or end of a row, as well as the top, bottom, or center of a column."
        >
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box box--bg">
                <div class="l-flex-row l-flex-start--xs">
                  <div class="l-flex-col--xs-6">
                    <div class="box">.l-flex-start--*</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box box--bg">
                <div class="l-flex-row l-flex-center--xs">
                  <div class="l-flex-col--xs-6">
                    <div class="box">.l-flex-center--*</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box box--bg">
                <div class="l-flex-row l-flex-end--xs">
                  <div class="l-flex-col--xs-6">
                    <div class="box">.l-flex-end--*</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box box--bg">
                <div class="l-flex-row l-flex-top--xs">
                  <div class="l-flex-col--xs-6">
                    <div class="box box--large"></div>
                  </div>
                  <div class="l-flex-col--xs-6">
                    <div class="box">.l-flex-top--*</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box box--bg">
                <div class="l-flex-row l-flex-middle--xs">
                  <div class="l-flex-col--xs-6">
                    <div class="box box--large"></div>
                  </div>
                  <div class="l-flex-col--xs-6">
                    <div class="box">.l-flex-middle--*</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box box--bg">
                <div class="l-flex-row l-flex-bottom--xs">
                  <div class="l-flex-col--xs-6">
                    <div class="box box--large"></div>
                  </div>
                  <div class="l-flex-col--xs-6">
                    <div class="box">.l-flex-bottom--*</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          switch={false}
          title="Distribution"
          text="These classes will distribute space as directed around items within the grid. Use .around to move space evenly around an element within a grid and .between to move space between elements within a grid."
        >
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box box--bg">
                <div class="l-flex-row l-flex-around--xs">
                  <div class="l-flex-col--xs-5">
                    <div class="box">.l-flex-around-*</div>
                  </div>
                  <div class="l-flex-col--xs-5">
                    <div class="box">.l-flex-around-*</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box box--bg">
                <div class="l-flex-row l-flex-between--xs">
                  <div class="l-flex-col--xs-5">
                    <div class="box">.l-flex-between-*</div>
                  </div>
                  <div class="l-flex-col--xs-5">
                    <div class="box">.l-flex-between-*</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Showcase>

        <Showcase
          site={data.site}
          switch={false}
          title="Row Breaks"
          text="Insert a row break to separate content in two rows that, combined, do not reach the full width of the grid."
        >
          <div class="l-flex-row">
            <div class="l-flex-col--xs-7">
              <div class="box">Row 1</div>
            </div>
            <div class="l-flex-row--break"></div>
            <div class="l-flex-col--xs-4">
              <div class="box box--large">Row 2</div>
            </div>
          </div>
        </Showcase>

        <Showcase
          site={data.site}
          switch={false}
          title="Reordering"
          text="Use Flexbox classes to reorder or reverse elements in a grid without altering their structure in the code."
        >
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box box--bg">
                <div class="l-flex-row l-flex-around--xs">
                  <div class="l-flex-col--xs">
                    <div class="box box--inactive">1</div>
                  </div>
                  <div class="l-flex-col--xs">
                    <div class="box box--inactive">2</div>
                  </div>
                  <div class="l-flex-col--xs l-flex-first--xs">
                    <div class="box">.l-flex-first--*</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box box--bg">
                <div class="l-flex-row l-flex-around--xs">
                  <div class="l-flex-col--xs">
                    <div class="box box--inactive">2</div>
                  </div>
                  <div class="l-flex-col--xs">
                    <div class="box box--inactive">3</div>
                  </div>
                  <div class="l-flex-col--xs l-flex-last--xs">
                    <div class="box">.l-flex-last--*</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="l-flex-row">
            <div class="l-flex-col--xs">
              <div class="box box--bg">
                .l-flex-column--reverse
                <div class="l-flex-row l-flex-dir--column l-flex-col--reverse">
                  <div class="l-flex-col--xs">
                    <div class="box box--inactive">1</div>
                  </div>
                  <div class="l-flex-col--xs">
                    <div class="box box--inactive">2</div>
                  </div>
                  <div class="l-flex-col--xs">
                    <div class="box box--inactive">3</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}
